import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';
import { BannerContext } from '@confluence/banners';
import { TemplateEditorLoader as NextTemplateEditor } from '@confluence/template-editor';

import { ClassicEditorContextProviderLoader } from '../../ClassicEditorContextProvider';

const bannerContextValue = { includeTopNav: false };

export const TemplateEditorRoute = ({ params: { contentId, spaceKey, pluginKey, moduleKey } }) => {
	const id = !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;

	return (
		<Screen
			screenEvent={{
				name: 'editTemplatePageScreen',
				id: id || '',
			}}
			pageState={{
				contentId: id,
				spaceKey,
			}}
		>
			<BannerContext.Provider value={bannerContextValue}>
				<ClassicEditorContextProviderLoader>
					<NextTemplateEditor templateId={id} spaceKey={spaceKey} />
				</ClassicEditorContextProviderLoader>
			</BannerContext.Provider>
		</Screen>
	);
};

TemplateEditorRoute.propTypes = {
	params: PropTypes.shape({
		contentId: PropTypes.string,
		spaceKey: PropTypes.string,
		pluginKey: PropTypes.string,
		moduleKey: PropTypes.string,
	}),
};
